import styled from 'styled-components';

const PanelTitle = styled.div`
	img {
		width: 30px;
		height: 30px;
	}

	span {
		font-family: 'GT Walsheim Pro';
		font-weight: bold;
		font-size: 18px;
		line-height: 21px;
		color: #fff;
		cursor: default;
	}
`;

export { PanelTitle };
